import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { first, subscribeOn } from 'rxjs/operators';
import { UsuariosService, AlertService, MenuService, UsuariosTiposService, MaquinasService } from '@app/_services';
import { MustMatch } from '@app/_helpers';
import { TranslateService } from '@ngx-translate/core';

import { GroupResult, groupBy } from '@progress/kendo-data-query';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { TimeSelectorComponent } from '@progress/kendo-angular-dateinputs';
import { TiposHerramientasDetalleComponent } from '@app/herramientas/tiposHerramientasDetalle/tiposHerramientasDetalle.component';
@Component({
  selector: 'app-eskola-alumnos-detalle',
  templateUrl: './eskola_alumnosDetalle.component.html'
})
export class Eskola_AlumnosDetalleComponent implements OnInit {

  id: number;
  alumno: any;
  isAddMode: boolean;
  loading: false;
  user = this.usuariosService.userValue;

  //validacion
  errorNombreVacio: boolean;
  errorNombreUsuarioVacio: boolean;
  errorApellido1Vacio: boolean;
  errorApellido2Vacio: boolean;
  errorEmailVacio: boolean;
  errorEmailNoValido: boolean;
  errorTelefonoVacio: boolean;
  errorContrasennaVacia: boolean;
  errorContrasennasNoCoinciden: boolean;
  errorTelefonoNoValido: boolean;
  errorConfirmarContrasenaVacia: boolean;
  errorContrasenna6caracteres: boolean;




  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private translateService: TranslateService,
    private usuariosService: UsuariosService,
    private usuariosTiposService: UsuariosTiposService,
    private alertService: AlertService,
    private menuService: MenuService,
    private maquinasService: MaquinasService
  ) {


  }

  ngOnInit() {
    this.errorNombreVacio = false;
    this.errorNombreUsuarioVacio = false;
    this.errorApellido1Vacio = false;
    this.errorApellido2Vacio = false;
    this.errorEmailVacio = false;
    this.errorEmailNoValido = false;
    this.errorTelefonoVacio = false;
    this.errorContrasennaVacia = false;
    this.errorContrasennasNoCoinciden = false;
    this.errorConfirmarContrasenaVacia = false;
    this.errorTelefonoNoValido = false;
    this.errorContrasenna6caracteres = false;


    this.id = this.route.snapshot.params['id'];
    this.isAddMode = !this.id;

    debugger;
    this.alumno = {
      id: -1,
      NombreUsuario: "",
      Nombre: "",
      Apellido1: "",
      Apellido2: "",
      Email: "",
      telefono: "",
      observaciones: "",
      Activo: true,
      Password: "",
      ConfirmPassword: "",
      Usuarios_tiposId: 6,
      UsuarioTipo: "Alumno",
      IdDb: this.user.idDb,
      Idioma: this.user.idioma,
      Tema: this.user.tema,
      MenuExpandido: this.user.menuExpandido,
      CondicionesAceptadas: true,
      GestionUsuarios: 1,

    }



    if (!this.isAddMode) {
      this.usuariosService.getUsuarioAlumnos(this.id.toString()).subscribe(res => {
        this.alumno = res[0];
        this.alumno.NombreUsuario = res[0].nombreUsuario;
        this.alumno.Nombre = res[0].nombre;
        this.alumno.Apellido1 = res[0].apellido1;
        this.alumno.Apellido2 = res[0].apellido2;
        this.alumno.Email = res[0].email;
        this.alumno.Activo = res[0].activo;
        this.alumno.Password = "";
        this.alumno.ConfirmPassword = "";
        this.alumno.Usuarios_tiposId = res[0].usuarios_TiposId;
        this.alumno.UsuarioTipo = res[0].usuarioTipo;
        this.alumno.IdDb = res[0].idDb;
        this.alumno.Tema = res[0].tema;
        this.alumno.MenuExpandido = res[0].menuExpandido;
        this.alumno.CondicionesAceptadas = true;
        this.alumno.GestionDocumentalService = res[0].gestionUsuarios;
        this.alumno.Idioma = res[0].idioma;
        this.alumno.telefono = res[0].telefono;
      });
    }

  }

  guardarClick() {
    // if (this.isAddMode) {
    //   this.alumno.NombreUsuario = this.alumno.Email;
    // }

    if (this.validar()) {
      if (this.isAddMode) {
        this.alumno.Password = this.alumno.NombreUsuario;
        this.alumno.ConfirmPassword = this.alumno.NombreUsuario;
        this.usuariosService.create(this.alumno).subscribe(res => {
          this.usuariosService.assignColour(res['id']).subscribe(r => {
            this.alertService.success(this.translateService.instant('creadocorrectamente'), { keepAfterRouteChange: true });
            this.router.navigate(['../'], { relativeTo: this.route });
          });
        });
      } else {
        debugger;
        if(this.alumno.Password == ""){
          this.usuariosService.updateAlumnos(this.alumno).subscribe(res => {
            this.alertService.success(this.translateService.instant('actualizadocorrecto'), { keepAfterRouteChange: true });
            this.router.navigate(['../'], { relativeTo: this.route });
          });
        }else{
          this.usuariosService.update(this.alumno).subscribe(res => {
            this.alertService.success(this.translateService.instant('actualizadocorrecto'), { keepAfterRouteChange: true });
            this.router.navigate(['../'], { relativeTo: this.route });
          });
        }   
      }
    }
  }

  validar(): boolean {
    this.errorNombreVacio = false;
    this.errorNombreUsuarioVacio = false;
    this.errorApellido1Vacio = false;
    this.errorApellido2Vacio = false;
    this.errorEmailVacio = false;
    this.errorEmailNoValido = false;
    this.errorTelefonoVacio = false;
    this.errorContrasennaVacia = false;
    this.errorConfirmarContrasenaVacia = false;
    this.errorContrasennasNoCoinciden = false;
    this.errorTelefonoNoValido = false;
    this.errorContrasenna6caracteres = false;
    var correcto = true;


    if (this.alumno.NombreUsuario == "" || this.alumno.NombreUsuario == undefined) {
      this.errorNombreUsuarioVacio = true;
      correcto = false;
    }
    if (this.alumno.Nombre == "" || this.alumno.Nombre == undefined) {
      this.errorNombreVacio = true;
      correcto = false;
    }
    if (this.alumno.Apellido1 == "" || this.alumno.Apellido1 == undefined) {
      this.errorApellido1Vacio = true;
      correcto = false;
    }
    // if (this.alumno.Apellido2 == "" || this.alumno.Apellido2 == undefined) {
    //   this.errorApellido2Vacio = true;
    //   correcto = false;
    // }
    if (this.alumno.Email == "" || this.alumno.Email == undefined) {
      this.errorEmailVacio = true;
      correcto = false;
    } else if (!this.alumno.Email.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)) {
      this.errorEmailNoValido = true;
      correcto = false;
    }
    // if (this.alumno.telefono == "" || this.alumno.telefono == undefined) {
    //   this.errorTelefonoVacio = true;
    //   correcto = false;
    // } else {
    //   if (!this.alumno.telefono.match("^\\+?[0-9]{9,12}$")) {
    //     this.errorTelefonoNoValido = true;
    //     correcto = false;
    //   }

    // }
    debugger;
    if (this.isAddMode) {
      // if (this.alumno.Password == "" || this.alumno.Password == undefined) {
      //   this.errorContrasennaVacia = true;
      //   correcto = false;
      // } else if (this.alumno.Password.length < 6) {
      //   this.errorContrasenna6caracteres = true;
      //   correcto = false;
      // } else if (this.alumno.ConfirmPassword == "" || this.alumno.Password == undefined) {
      //   this.errorConfirmarContrasenaVacia = true;
      //   correcto = false;
      // } else if (this.alumno.Password != this.alumno.ConfirmPassword) {
      //   this.errorContrasennasNoCoinciden = true;
      //   correcto = false;
      // }


    } else {
      if ((this.alumno.Password == "" || this.alumno.Password == undefined) && (this.alumno.ConfirmPassword == "" || this.alumno.Password == undefined)) {
        correcto = true;
      } else if (this.alumno.Password == "" || this.alumno.Password == undefined) {
        this.errorContrasennaVacia = true;
        correcto = false;
      } else if (this.alumno.Password.length < 6) {
        this.errorContrasenna6caracteres = true;
        correcto = false;
      } else if (this.alumno.ConfirmPassword == "" || this.alumno.Password == undefined) {
        this.errorConfirmarContrasenaVacia = true;
        correcto = false;
      } else if (this.alumno.Password != this.alumno.ConfirmPassword) {
        this.errorContrasennasNoCoinciden = true;
        correcto = false;
      }     
    }

    return correcto;
  }

}
